import { Link, useLocation } from "react-router-dom";
import {
  Feather, SignOut, HardDrives, Receipt, CalendarBlank, Gear, DownloadSimple, List, X as XIcon,
} from "@phosphor-icons/react";
import { useState } from "react";
import { Button } from "./ui/button";

const NAV = [
  { to: "/dashboard", label: "Diary", Icon: Feather, testId: "nav-home" },
  { to: "/calendar", label: "Calendar", Icon: CalendarBlank, testId: "nav-calendar" },
  { to: "/history", label: "History", Icon: Receipt, testId: "nav-history" },
  { to: "/storage", label: "Storage", Icon: HardDrives, testId: "nav-storage" },
  { to: "/export", label: "Export", Icon: DownloadSimple, testId: "nav-export" },
  { to: "/settings", label: "Settings", Icon: Gear, testId: "nav-settings" },
];

export default function TopNav({ user, onLogout }) {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-30 backdrop-blur-md bg-background/85 border-b border-border">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/dashboard" data-testid="nav-brand" className="flex items-center gap-2">
          <Feather size={22} weight="duotone" className="text-primary" />
          <span className="font-serif text-2xl tracking-tight">Antic</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {NAV.map(({ to, label, Icon, testId }) => (
            <Link
              key={to}
              to={to}
              data-testid={testId}
              className={`px-3 py-2 rounded-full text-xs uppercase tracking-[0.2em] font-semibold flex items-center gap-2 transition-colors ${
                pathname === to
                  ? "text-primary"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              <Icon size={14} weight={pathname === to ? "duotone" : "regular"} /> {label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-2">
          {user?.picture && (
            <img src={user.picture} alt="" className="h-8 w-8 rounded-full border border-border hidden sm:block" />
          )}
          <Button
            data-testid="nav-logout-btn"
            variant="ghost"
            size="sm"
            onClick={onLogout}
            className="text-xs uppercase tracking-[0.2em] hidden sm:inline-flex"
          >
            <SignOut size={16} className="mr-1" /> Sign out
          </Button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden p-2 rounded-full hover:bg-muted"
            aria-label="Menu"
          >
            {open ? <XIcon size={18} /> : <List size={18} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-border bg-background/95" data-testid="mobile-menu">
          <ul>
            {NAV.map(({ to, label, Icon, testId }) => (
              <li key={to}>
                <Link
                  to={to}
                  onClick={() => setOpen(false)}
                  data-testid={`m-${testId}`}
                  className={`flex items-center gap-3 px-6 py-4 text-sm uppercase tracking-[0.2em] font-semibold ${
                    pathname === to ? "text-primary" : "text-muted-foreground"
                  }`}
                >
                  <Icon size={16} /> {label}
                </Link>
              </li>
            ))}
            <li className="border-t border-border">
              <button
                onClick={() => { setOpen(false); onLogout(); }}
                className="w-full text-left flex items-center gap-3 px-6 py-4 text-sm uppercase tracking-[0.2em] font-semibold text-muted-foreground"
              >
                <SignOut size={16} /> Sign out
              </button>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}
